import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link } from "react-router-dom"
import { fetchCars, fetchEntity, tablefilter } from '../actions'
import { getCars, getEntity, getTableFilter } from '../reducers'
import {
    Box,
    Button,
    IconButton,
    Input,
    Select,
    useColorModeValue
} from '@chakra-ui/react'
import { DownloadIcon, RepeatIcon } from '@chakra-ui/icons'
import Layout from '../layout'
import DataTable from 'react-data-table-component'
import { CSVLink } from "react-csv"

const columns = [
    { name: 'id', selector: row => row.id, sortable: true },
    { name: 'VIN', selector: row => row.vin, sortable: true },
    { name: 'Año', selector: row => row.annio, sortable: true },
    { name: 'Tipo de Vehiculo', selector: row => row.clase, sortable: true },
    { name: 'Modelo', selector: row => row.modelo, sortable: true },
    { name: 'Marca', selector: row => row.marca, sortable: true },
    { name: 'Disponibilidad', selector: row => row.disponibilidad, sortable: true },
    { name: 'Opciones', selector: row => row.opcion, sortable: false },
];

const CarList = () => {

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchCars())
        dispatch(fetchEntity('anno-vehiculo'))
        dispatch(fetchEntity('clase'))
        dispatch(fetchEntity('marca'))
    }, [])

    const cars = useSelector(state => getCars(state))
    const annos = useSelector(state => getEntity(state, "anno-vehiculo"))
    const clases = useSelector(state => getEntity(state, "clase"))
    const marcas = useSelector(state => getEntity(state, "marca"))
    const filter = useSelector(state => getTableFilter(state, "car"))

    const color = useColorModeValue('white', 'gray.800')

    const changeFilter = (value, element) => {
        dispatch(tablefilter("car", element, value))
    }

    //Datos de la table
    const filteredItems = cars.filter(item => {
        let flag = true
        if (filter.vin !== '') {
            if (item.VIN) {
                flag = item.VIN.toLowerCase().includes(filter.vin.toLowerCase())
            }
        }
        if (filter.anno !== '') {
            flag = Number(item.nAño) === Number(filter.anno)
        }
        if (filter.tipo !== '') {
            flag = item.cClase === filter.tipo
        }
        if (filter.marca !== '') {
            flag = item.cMarca === filter.marca
        }
        if (filter.disponibilidad !== '') {
            flag = item.cDisponibilidad === filter.disponibilidad
        }
        return flag
    })


    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            changeFilter("", "vin")
            changeFilter("", "tipo")
            changeFilter("", "anno")
            changeFilter("", "marca")
            changeFilter("", "disponibilidad")
        }
        return <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '3px' }}>

            <Select onChange={e => changeFilter(e.target.value, "marca")} >
                <option value={""}>Marca</option>
                {marcas.map(marca =>
                    marca.cNomCod === filter.marca ?
                        <option value={marca.cNomCod} key={marca.nValor} selected>{marca.cNomCod}</option>
                        :
                        <option value={marca.cNomCod} key={marca.nValor}>{marca.cNomCod}</option>
                )}
            </Select>

            <Select onChange={e => changeFilter(e.target.value, "tipo")} style={{ width: '200px ' }}>
                <option value={""}>Tipo de vehículo</option>
                {clases.map(clase =>
                    clase.cNomcod === filter.tipo ?
                        <option value={clase.cNomcod} key={clase.nValor} selected>{clase.cNomcod}</option>
                        :
                        <option value={clase.cNomcod} key={clase.nValor}>{clase.cNomcod}</option>
                )}
            </Select>

            <Select onChange={e => changeFilter(e.target.value, "anno")} >
                <option value={""}>Año</option>
                {annos.map(anno =>
                    anno.cNomCod === filter.anno ?
                        <option value={anno.cNomCod} key={anno.nValor} selected>{anno.cNomCod}</option>
                        :
                        <option value={anno.cNomCod} key={anno.nValor}>{anno.cNomCod}</option>
                )}
            </Select>

            <Input placeholder="Filtrar por VIN" onChange={e => changeFilter(e.target.value, "vin")} value={filter.vin} />

            <Select onChange={e => changeFilter(e.target.value, "disponibilidad")} >
                <option value={""} selected={filter.disponibilidad === ''} >Disponibilidad</option>
                <option value={'Disponible'} selected={filter.disponibilidad === 'Disponible'} >Disponible</option>
                <option value={'No disponible'} selected={filter.disponibilidad === 'No Disponible'} >No Disponible</option>
            </Select>
            <IconButton aria-label='Clean' icon={<RepeatIcon />} onClick={handleClear} />
            <CSVLink
                filename={"vehiculos.csv"}
                headers={[
                    { label: "id", key: "id" },
                    { label: "VIN", key: "VIN" },
                    { label: "Año", key: "annio" },
                    { label: "Tipo de Vehiculo", key: "clase" },
                    { label: "Modelo", key: "modelo" },
                    { label: "Marca", key: "marca" },
                    { label: "N. Pasajeros", key: "pasajeros" },
                    { label: "Color", key: "color" },
                    { label: "Kilometraje", key: "recorrido" },
                    { label: "Combustible", key: "combustible" },
                    { label: "Cilindraje", key: "motor" },
                    { label: "Transmisión", key: "transmision" },
                    { label: "Tracción", key: "traccion" },
                    { label: "Tapizado", key: "tapizado" },
                    { label: "Vidrios", key: "vidrio" },
                    { label: "Aire Acondicionado", key: "aire_acondicionado" },
                    { label: "Categoria", key: "destacado" },
                    { label: "Valor", key: "valor" },
                    { label: "Prima", key: "prima" },
                    { label: "Autolote", key: "autolote" },
                    { label: "Disponibilidad", key: "disponibilidad" }
                ]}
                data={filteredItems.map(car => {
                    return {
                        id: car.id,
                        vin: car.VIN,
                        annio: car.nAño,
                        clase: car.cClase,
                        modelo: car.cModelo,
                        marca: car.cMarca,
                        disponibilidad: car.cDisponibilidad,
                        color: car.cColor,
                        recorrido: `${car.nRecorrido} ${car.cRecorridoTipo}`,
                        combustible: car.cCombustible,
                        motor: car.cMotor,
                        transmision: car.cTransmision,
                        traccion: car.cTraccion,
                        tapizado: car.cTapizado,
                        aire_acondicionado: car.bAc,
                        vidrio: car.cVidrios,
                        pasajeros: car.nPasajeros,
                        valor: car.nValor,
                        prima: car.nPrima,
                        destacado: car.nDestacado,
                        autolote: car.autolote,
                    }
                })}
            >
                <IconButton aria-label='download' icon={<DownloadIcon />} />
            </CSVLink>
        </div>

    }, [filter])

    return (
        <Layout>
            <Box
                w={'full'}
                bg={color}
                rounded={'md'}
                m={3}
                p={6}
            >
                <DataTable
                    pagination
                    columns={columns}
                    defaultSortAsc={false}
                    defaultSortFieldId={1}
                    subHeader
                    persistTableHead
                    subHeaderComponent={subHeaderComponentMemo}
                    data={filteredItems.map(car => {
                        return {
                            id: car.id,
                            vin: car.VIN,
                            annio: car.nAño,
                            clase: car.cClase,
                            modelo: car.cModelo,
                            marca: car.cMarca,
                            disponibilidad: car.cDisponibilidad,
                            opcion: <Link to={`car/${car.id}/edit`}><Button colorScheme="teal" variant="outline">Editar</Button></Link>
                        }
                    })}
                />
            </Box>
        </Layout>
    )
}


export default CarList